import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Img from "../../../../assets/img/Home/cover-img(1).png";
import star from "../../../../assets/img/icons/star.svg";
import calendar from "../../../../assets/img/icons/calendar-2 2.svg";
import line from "../../../../assets/img/dashboard/Union.svg";
import IconBox from "../../../shared/IconBox";
import PersianNumber from "../../../shared/PersianNumber";
import eye from "../../../../assets/img/dashboard/eye.svg"
import edit from "../../../../assets/img/dashboard/edit-2.svg"
import calendars from "../../../../assets/img/dashboard/calendargreen.svg"
import trash from "../../../../assets/img/dashboard/trash.svg"
import Button from "../../../shared/Button";
const EditDropbox = ({id,code,slug})=>{
const navigate = useNavigate()

  return(
    <div className="EditDropbox">
     <ul className=" "> 
       <li onClick={()=> navigate(`/place/edit/${code}/${slug}/${id}`)}>
         <img src={eye}/>
         <p>ویراش اقامتگاه</p>
       </li>
       <hr/>
       <li onClick={()=> navigate(`/place/${code}/${slug}`)}>
         <img src={calendars}/>
         <p>پــیـش نــمایــش</p>
       </li>
       <hr/>

       <li>
         <img src={eye}/>
         <p>تقویم اقامتگاه</p>
       </li>
     </ul>
    <div className="center">
    <Button className="red-button" varient={"primary"}>
       <div className="flex gap-[6px]">
         <img src={trash}/>
         <p>حذف اقامتگاه</p>
       </div>
     </Button>

    </div>
    </div>
  )
}
const RecentCard = ({info,reserved}) => {
  function round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }

  const navigate = useNavigate();
  return (
    <div className="RecentCard mb-[50px]" >
      <div className=" relative PlaceCard-img">
        <img src={info.thumbnail?.path} alt="img-place" className="PlaceCard-img" />
      </div>
      <div className="RecentCard__info">
      <div className="d-flex-space">
      <div className="d-flex-align  mt-[19px] ">
          {/* <div className="text-[#12171C] text-[20px] mb-[-7px] font-[900]">
            {round(info.rating_value, 1)}
          </div> */}
          <img src={star} className="mr-[5px]" />
        </div>
        <div className="relative icon-button-line">
            <IconBox className="" white small={true}  >
                <img src={line}/>
            </IconBox>
            <EditDropbox id={info.id} slug={info.slug} code={info.code}/>
        </div>
      </div>
        <div className="my-[10px] text-[#797D82] text-[15px] font-[500]">
           {info.type}     ،   {info.city}  ، <PersianNumber number={info.rooms_count} /> اتاق 

        </div>
        
          <h4 className="mb-[17px] text-[20px] font-[700] text-[#292D32]">
           {info.title}
          </h4>
      

        <div className="flex items-center footer-card gap-[16px]">
          <div className="flex price-box ">
            <div className="pre-cost ml-[4px]">از</div>

            <div className="cost mx-[2px]"> <PersianNumber number={info.price}/></div>
            <div className="pre-cost">تومان</div>
          </div>

        {reserved &&  <div className="tip-box flex">
            <div> . وضعیت رزرو نشده </div>
          </div>}
        </div>
       {reserved && <div className="flex gap-[16px] items-center">
            <img src={calendar}/>
            <p className="my-[10px] text-[#797D82] text-[15px] font-[500]">تاریخ رزرو : 24 / 8 / 1401</p>
        </div>}
      </div>
    </div>
  );
};

export default RecentCard;
